export default "__VITE_ASSET__CsJhy_q2__"